import BasicRepository from "./basicRepository";
import Client from "../client";

class ProxyRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("Proxies", client);
    }
}

export default ProxyRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/proxyRepository.ts